module.exports = __webpack_public_path__ + "inputs/img/home.587c9d79.png";